<div class="title flex align-items-center justify-content-center">
    <div class="icon" [ngStyle]="{'-webkit-mask': 'url(' + icon + ') no-repeat'}"></div>
    <ng-content>
        
    </ng-content> 
</div>